/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthMessage } from '../models/AuthMessage';
import type { AuthReference } from '../models/AuthReference';
import type { AuthToken } from '../models/AuthToken';
import type { CompletionDataUser } from '../models/CompletionDataUser';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountService {

    /**
     * @param referenceToken
     * @returns AuthToken Success
     * @returns AuthMessage Accepted
     * @throws ApiError
     */
    public static accountBankIdStatus(
        referenceToken?: string,
    ): CancelablePromise<AuthToken | AuthMessage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Account/Status',
            query: {
                'referenceToken': referenceToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * @param referenceToken
     * @returns any Success
     * @throws ApiError
     */
    public static accountCancelBankId(
        referenceToken?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Account/Cancel',
            query: {
                'referenceToken': referenceToken,
            },
        });
    }

    /**
     * @param ssn
     * @returns AuthReference Success
     * @throws ApiError
     */
    public static accountLoginBankId(
        ssn?: string,
    ): CancelablePromise<AuthReference> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Account/Auth',
            query: {
                'ssn': ssn,
            },
        });
    }

    /**
     * @returns AuthReference Success
     * @throws ApiError
     */
    public static accountLoginBankIdQr(): CancelablePromise<AuthReference> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Account/QR',
        });
    }

    /**
     * @param sessionId
     * @returns any Success
     * @throws ApiError
     */
    public static accountDeleteAccount(
        sessionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Account/DeleteAccount',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @returns any Success
     * @throws ApiError
     */
    public static accountLogout(
        sessionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Account/Logout',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param sessionId
     * @returns any Success
     * @throws ApiError
     */
    public static accountLoginStatus(
        sessionId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Account/LoginStatus',
            query: {
                'sessionId': sessionId,
            },
        });
    }

    /**
     * @param token
     * @returns any Success
     * @throws ApiError
     */
    public static accountLoginBroker(
        token?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Account/LoginBroker',
            query: {
                'token': token,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static accountLoginUser(
        requestBody?: CompletionDataUser,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Account/LoginUser',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
